var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanneDuploVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 568,
    viewBox: "0 0 430 568",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 397,
    height: 279,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 397,
    height: 279,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.25 106.25H188.75C184.608 106.25 181.25 109.608 181.25 113.75V166.25C181.25 170.392 184.608 173.75 188.75 173.75H241.25C245.392 173.75 248.75 170.392 248.75 166.25V113.75C248.75 109.608 245.392 106.25 241.25 106.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.875 132.5C204.982 132.5 207.5 129.982 207.5 126.875C207.5 123.768 204.982 121.25 201.875 121.25C198.768 121.25 196.25 123.768 196.25 126.875C196.25 129.982 198.768 132.5 201.875 132.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.75 151.25L230 132.5L188.75 173.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 288.5,
    width: 397,
    height: 279,
    rx: 9.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 288.5,
    width: 397,
    height: 279,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.25 394.25H188.75C184.608 394.25 181.25 397.608 181.25 401.75V454.25C181.25 458.392 184.608 461.75 188.75 461.75H241.25C245.392 461.75 248.75 458.392 248.75 454.25V401.75C248.75 397.608 245.392 394.25 241.25 394.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.875 420.5C204.982 420.5 207.5 417.982 207.5 414.875C207.5 411.768 204.982 409.25 201.875 409.25C198.768 409.25 196.25 411.768 196.25 414.875C196.25 417.982 198.768 420.5 201.875 420.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.75 439.25L230 420.5L188.75 461.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanneDuploVertical);
export default __webpack_public_path__ + "static/media/banneDuploVertical.4f5088eb8c968e4b062590f21b52042b.svg";
export { ForwardRef as ReactComponent };